import { Box, Button, Stack } from '@mui/material';
import React, { useEffect, useRef, useState } from 'react';
import useColor from '../../../../hooks/site/useColor';
import useBootstrapSize from '../../../../hooks/useBootstrapSize';
import ShowContainer from '../../../../components/material-ui/ShowContainer';
import { IconMenu } from '@tabler/icons-react';
import { useEventListener } from 'usehooks-ts';

export default function MenuContainer({
  children,
  maxHeight,
  openMobileMenu,
  setOpenMobileMenu,
  usersContentRef,
  pined
}) {
  const { isLessTablet, isBigDesktop } = useBootstrapSize();
  const { background } = useColor();

  const [activePin, setActivePin] = useState(false);

  const menuRef = useRef();
  const onlyMenuRef = useRef();
  const width = isBigDesktop ? 320 : 256;
  const styleXs = isLessTablet
    ? {
        position: 'fixed',
        backgroundColor: background.default,
        p: 3,
        px: 1.5,
        pt: 2,
        right: 0,
        top: 64,
        height: '100svh',
        maxHeight: 'calc( 100svh - 64px)',
        zIndex: 99,
        display: openMobileMenu ? '' : 'none'
      }
    : {};

  const sxPin = {
    position: 'fixed',
    top: 0,
    width: width + 10,
    maxHeight: '100svh',
    overflow: 'auto',
    paddingBottom: 5
  };

  useEventListener('scroll', () => {
    if (!menuRef.current) return;
    if (!pined) return;
    if (isLessTablet) return;
    if (usersContentRef.current?.offsetHeight <= onlyMenuRef.current?.offsetHeight) return;

    const rect = menuRef.current.getBoundingClientRect();
    const currentTopOffset = rect.top;
    setActivePin(currentTopOffset <= 0);
  });

  useEffect(() => {
    if (!isLessTablet) return;
    setActivePin(false);
  }, [isLessTablet]);

  return (
    <Stack
      minWidth={256}
      width={width}
      direction={'column'}
      gap={1}
      maxHeight={maxHeight}
      overflow={'auto'}
      sx={styleXs}
      ref={menuRef}>
      <ShowContainer condition={isLessTablet}>
        <Box sx={{ marginLeft: 'auto' }}>
          <Button onClick={() => setOpenMobileMenu((prev) => !prev)} sx={{ p: 0.5 }}>
            <IconMenu />
          </Button>
        </Box>
      </ShowContainer>
      <Stack ref={onlyMenuRef} gap={4} sx={activePin && pined ? sxPin : {}}>
        {children}
      </Stack>
    </Stack>
  );
}
